import { call, put, takeLatest, select } from 'redux-saga/effects';
import { current, PayloadAction } from '@reduxjs/toolkit';

import { getApiClient } from '@app/utils/apiUtils';
import {
  getGames,
  getGamesFailure,
  getGamesSuccess,
  updateGameOpenMarketStatus,
  updateGameOpenMarketStatusFailure,
  updateGameOpenMarketStatusSuccess
} from './reducer';
import { message } from 'antd';

function* getGamesSaga() {
  try {
    // Get current state to determine pagination and filter params
    const state = yield select();
    const currentPage = state.gamesContainer?.currentPage || 1;
    const pageSize = state.gamesContainer?.pageSize || 10;
    const currentLeague = state.gamesContainer?.currentLeague || 'all';
    const queryParams = new URLSearchParams();
    queryParams.append('pageNumber', currentPage);
    queryParams.append('limit', pageSize);

    // Only add league filter if not 'all'
    if (currentLeague !== 'all') {
      queryParams.append('league', currentLeague);
    }
    const queryString = queryParams.toString();

    const response = yield call([getApiClient(), 'get'], `/games?${queryString}`);

    // Handle both possible response structures
    const responseData = response.data.data;
    const games = responseData?.games || responseData || [];
    const paginationData = {
      games,
      totalCount: responseData?.totalCount || games.length,
      pageNumber: responseData?.pageNumber || currentPage,
      limit: responseData?.limit || pageSize,
      totalPages: responseData?.totalPages || Math.ceil((responseData?.totalCount || games.length) / pageSize)
    };

    yield put(getGamesSuccess(paginationData));
  } catch (error: any) {
    console.error('GamesSaga: getGamesSaga error:', error);
    yield put(getGamesFailure(error?.response?.data?.message || 'Failed to fetch games'));
  }
}

function* updateGameOpenMarketStatusSaga(action: PayloadAction<{ gameId: string; enabled: boolean }>) {
  try {
    const { gameId, enabled } = action.payload;

    // Use the publish endpoint for changing draft to upcoming

    const response = yield call([getApiClient(), 'post'], '/games/set-open-betting', {
      gameId,
      enabled,
      market: 'Spread'
    });
    if (response.ok) {
      message.success('Game is enabled for Open Market successfully');
      yield put(updateGameOpenMarketStatusSuccess({ gameId, enabled }));
    } else {
      message.error(response.data.error || 'Failed to update game status');
      yield put(updateGameOpenMarketStatusFailure(response.data.error || 'Failed to update game status'));
    }
  } catch (error: any) {
    message.error(error?.response?.data?.message || error.message || 'Failed to update game status');

    yield put(
      updateGameOpenMarketStatusFailure(
        error?.response?.data?.message || error.message || 'Failed to update game status'
      )
    );
  }
}

export default function* gamesContainerSaga() {
  yield takeLatest(getGames.type, getGamesSaga);
  yield takeLatest(updateGameOpenMarketStatus.type, updateGameOpenMarketStatusSaga);
}
